export const getPortalBasename = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-prefix"]');
  const prefix = metaTag === null || metaTag === void 0 ? void 0 : metaTag.content;
  if (!prefix) {
    return undefined;
  }
  return prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
};
export const getPortalName = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-name"]');
  return metaTag === null || metaTag === void 0 ? void 0 : metaTag.content;
};
export function getPortalAccountId() {
  const metaTag = document.querySelector('meta[name="x-hs-portals-account-id"]');
  const parsed = Number(metaTag === null || metaTag === void 0 ? void 0 : metaTag.content);
  return Number.isNaN(parsed) ? undefined : parsed;
}
export function getPortalInstanceId() {
  const metaTag = document.querySelector('meta[name="x-hs-portals-instance-id"]');
  const parsed = Number(metaTag === null || metaTag === void 0 ? void 0 : metaTag.content);
  return Number.isNaN(parsed) ? undefined : parsed;
}
export const getPortalHublet = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-hublet"]');
  return metaTag === null || metaTag === void 0 ? void 0 : metaTag.content;
};
export const getPortalEnv = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-env"]');
  return metaTag === null || metaTag === void 0 ? void 0 : metaTag.content;
};
export const setPortalRuntimeGlobals = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const portalEnv = getPortalEnv();
  const portalHublet = getPortalHublet();
  const windowWithGlobals = window;
  if (portalEnv) {
    windowWithGlobals.ENV = portalEnv;
  }
  if (portalHublet) {
    windowWithGlobals.HUBLET = portalHublet;
  }
};